@if (productPage && productPage.numberOfElements > 0) {
  @if (title) {
    <h1>{{title}}</h1>
  }
  @if (description) {
    <p>{{description}}</p>
  }
  <div class="js-overview-grid">
    <div [ngClass]="{loading: loading}" class="overview-grid overview-grid--cms">
      @if (productPage) {
        @for (product of productPage.content; track product) {
          <product-item-grid #productItemGridComponent
            (viewProductDetailClickEvent)="viewProductDetail($event)"
            [loggedIn]="userService.isLoggedIn()"
            [product]="product"
            (lazyLoad)="productItemGridComponent.doLoad($event)"
            class="overview-product">
          </product-item-grid>
        }
      }
    </div>
    @if (hasShowAllButton()) {
      <div class="button-bar" style="text-align: center;">
        <a class="button"
          [ngClass]="{'button--outline-white theme-btn-secondary-outline': !isWebsite(), 'button--secondary': isWebsite()}"
          href="{{getShowAllUrl()}}"
          i18n="@@spotlight.products.show.more">
					Show more
				</a>
      </div>
    }
  </div>
}
